import type { SVGProps } from 'react';

export function SubmitIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 32L54 12L46 54L32 38L10 32Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      <path d="M32 38L54 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
